<template>
  <div class='main-content sn-content'>
    <el-card class="box-card">
      <span style="text-align: left;">配额列表</span>
      <template>
        <el-table
          :data="userQuotaList"
          style="width: 100%;margin-top:10px;">
          <el-table-column
            label="配额"
            prop="name">

          </el-table-column>

          <el-table-column
            prop="quota"
            label="配额数量">
          </el-table-column>

        </el-table>
      </template>
    </el-card>

  </div>
</template>

<script>
  import {Message} from "element-ui";
  import PageComponent from '@/components/pageInfo/PageComponent'
  export default {
    components: {PageComponent},
    data() {
      return {
        userConfig: {},
        appliConfigs: [],
        userQuotaList:[]
      }
    },
    created() {
    },
    methods: {
      uacUserConfig: function () {
        this.getRequest('/uacUserConfig/getInfo', {"userId": this.$store.state.user.userId}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.userConfig = resp.data.result;
              this.appliConfigs = this.userConfig.appliQuota.split(",");
              var cloudSn = {"name": "授权码", "quota": this.userConfig.snQuota}
              var appli1 = {"name": "托管应用(应用存储容量GB)", "quota": this.appliConfigs[0]}
              var appli2 = {"name": "托管应用(应用数量)", "quota": this.appliConfigs[1]}
              var appli3 = {"name": "托管应用(应用并发数)", "quota": this.appliConfigs[2]}
              this.userQuotaList = [cloudSn, appli1, appli2, appli3]

            } else {
              Message.error(resp.data.message);
            }
          }
        })
      },


    }
    ,
    mounted: function () {
      this.uacUserConfig();
    }
    ,
    beforeDestroy() {

    }
  }
</script>

